import React, { useEffect, useState } from 'react';
import axios from 'axios';

const DashboardDG = ({ userId }) => {
    const [courriers, setCourriers] = useState([]);
    const [unreadCount, setUnreadCount] = useState(0);

    // Fonction pour charger les courriers
    const fetchCourriers = async () => {
        try {
            // Remplacez DIRECTEUR par ADMIN_PRINCIPAL pour vos tests
const response = await axios.get(`https://courriers.oscep.cd/liste_courriers.php?user_id=${userId}&role=ADMIN_PRINCIPAL`);
            if (response.data.success) {
                setCourriers(response.data.data);
                setUnreadCount(response.data.count_unread);
                updateBrowserBadge(response.data.count_unread);
            }
        } catch (error) {
            console.error("Erreur de chargement", error);
        }
    };

    // Mise à jour visuelle du badge dans l'onglet
    const updateBrowserBadge = (count) => {
        document.title = count > 0 ? `🔴 (${count}) G-COURRIER` : "G-COURRIER";
    };

    // Action pour marquer comme lu
    const marquerCommeLu = async (id) => {
        try {
            await axios.post('https://courriers.oscep.cd/marquer_lu.php', {
                courrier_id: id,
                user_id: userId
            });
            fetchCourriers(); // Rafraîchir la liste
        } catch (error) {
            console.error("Erreur lors du marquage", error);
        }
    };

    useEffect(() => {
        fetchCourriers();
        const interval = setInterval(fetchCourriers, 30000); // Auto-check toutes les 30s
        return () => clearInterval(interval);
    }, []);

    return (
        <div style={{ padding: '20px' }}>
            <h2>Tableau de Bord DG</h2>
            <div style={{ background: '#e74c3c', color: 'white', padding: '10px', borderRadius: '5px', display: 'inline-block', marginBottom: '20px' }}>
                Nouveaux courriers : {unreadCount}
            </div>

            <table border="1" style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
                <thead>
                    <tr style={{ background: '#f2f2f2' }}>
                        <th>N° Ordre</th>
                        <th>Expéditeur</th>
                        <th>Objet</th>
                        <th>Urgence</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {courriers.map((c) => (
                        <tr key={c.id} style={{ backgroundColor: c.is_read == 0 ? '#fff3cd' : 'white' }}>
                            <td>{c.num_ordre}</td>
                            <td>{c.expediteur}</td>
                            <td>{c.objet}</td>
                            <td>{c.is_urgent == 1 ? '🔥 URGENT' : 'Normal'}</td>
                            <td>
                                <a href={`https://courriers.oscep.cd/${c.scan_path}`} target="_blank" rel="noreferrer" onClick={() => marquerCommeLu(c.id)}>
                                    👁️ Voir le Scan
                                </a>
                                {c.is_read == 0 && (
                                    <button onClick={() => marquerCommeLu(c.id)} style={{ marginLeft: '10px' }}>Marquer lu</button>
                                )}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default DashboardDG;